/**
 * Formats a date for datetime-local input
 * @param {string|Date} date - The date to format
 * @returns {string} - Formatted date string (YYYY-MM-DDTHH:mm:ss)
 */
export const formatDateForInput = date => {
  if (!date) return ""
  const dateObj = new Date(date)
  return dateObj.toISOString().split(".")[0]
}

/**
 * Formats a date for display in the UI
 * @param {string|Date} date - The date to format
 * @returns {string} - Formatted date string in local format
 */
export const formatDateForDisplay = date => {
  if (!date) return "-"
  return new Date(date).toLocaleString("el-GR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  })
}

/**
 * Formats a date for API
 * @param {string|Date} date - The date to format
 * @returns {string|null} - Formatted date string for API or null
 */
export const formatDateForApi = date => {
  if (!date) return null

  // Create a Date object from the input
  const dateObj = new Date(date)

  // Check if the date is valid
  if (isNaN(dateObj.getTime())) return null

  // Format to YYYY-MM-DD
  const year = dateObj.getFullYear()
  const month = String(dateObj.getMonth() + 1).padStart(2, "0")
  const day = String(dateObj.getDate()).padStart(2, "0")
  const hours = String(dateObj.getHours()).padStart(2, "0")
  const minutes = String(dateObj.getMinutes()).padStart(2, "0")
  const seconds = String(dateObj.getSeconds()).padStart(2, "0")

  // Return in format YYYY-MM-DDTHH:MM:SS
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
}

/**
 * Handles date change from input and converts to ISO format
 * @param {string} value - The input value
 * @returns {string|null} - ISO formatted date string or null
 */
export const handleDateChange = value => {
  if (!value) return null
  // Format the date for API
  return formatDateForApi(value)
}
